import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useCart = create(
  persist(
    (set, get) => ({
      items: [],
      addItem: (product, variant, qty = 1) => {
        const key = variant ? `${product.id}-${variant.id}` : product.id;
        const items = [...get().items];
        const existing = items.find((i) => i.key === key);
        if (existing) {
          existing.qty += qty;
        } else {
          items.push({
            key,
            productId: product.id,
            slug: product.slug,
            name: product.name,
            image: variant?.image || product.images?.[0],
            price: variant ? variant.price : product.price,
            variant: variant ? { id: variant.id, size: variant.size } : null,
            isDigital: !!product.is_digital,
            qty,
          });
        }
        set({ items });
      },
      updateQty: (key, qty) => {
        if (qty < 1) return;
        set({ items: get().items.map((i) => (i.key === key ? { ...i, qty } : i)) });
      },
      removeItem: (key) => set({ items: get().items.filter((i) => i.key !== key) }),
      clear: () => set({ items: [] }),
    }),
    { name: "glowingifts-cart" }
  )
);

export const cartCount = (items) => items.reduce((s, i) => s + i.qty, 0);
export const cartTotal = (items) => items.reduce((s, i) => s + i.qty * i.price, 0);
